import { Controller } from 'stimulus'

// The LIMSey wordmark in the top row of the phone screens
// (app/views/mobile/_brand_row). It sits centered on the screen, and steps
// aside when Back would run into it: a long job number on a small phone.
// Back tells you where you're going, so it gets the room.
export default class extends Controller {
  static targets = ['back', 'mark']

  connect() {
    this.fit = this.fit.bind(this)
    this.fit()
    window.addEventListener('resize', this.fit)
  }

  disconnect() {
    window.removeEventListener('resize', this.fit)
  }

  fit() {
    if (!this.hasBackTarget || !this.hasMarkTarget) return

    this.element.classList.remove('is-cramped')
    const gap = 8
    const cramped = this.backTarget.getBoundingClientRect().right + gap > this.markTarget.getBoundingClientRect().left
    this.element.classList.toggle('is-cramped', cramped)
  }
}
